import { FC } from 'react';
import {
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  Link,
  ListItem,
  UnorderedList,
} from '@chakra-ui/react';

import webView from 'common/webView';
import Heading from 'components/_core/Heading';
import SunshineModal from 'components/_core/SunshineModal';
import Text from 'components/_core/Text';

import { locales } from './locales';

interface MixedActivityInfoProps {
  isOpen: boolean;
  onClose: () => void;
}

const MixedActivityInfo: FC<MixedActivityInfoProps> = ({ isOpen, onClose }) => {
  const { isInWebView } = webView;

  const content = (
    <>
      <Text>{locales.subtitle}</Text>
      <Text marginTop="space-16">{locales.example}</Text>
      <Text marginTop="space-16">{locales.categories?.title}</Text>
      <UnorderedList paddingLeft="space-8">
        <ListItem>
          <Link
            fontWeight="normal"
            href={locales.categories?.[1].url}
            target="_blank"
          >
            {locales.categories?.[1].title}
          </Link>{' '}
          {locales.categories?.[1].details}
        </ListItem>
        <ListItem>
          <Link
            fontWeight="normal"
            href={locales.categories?.[1].url}
            target="_blank"
          >
            {locales.categories?.[2].title}
          </Link>{' '}
          {locales.categories?.[2].details}
        </ListItem>
        <ListItem>
          <Link
            fontWeight="normal"
            href={locales.categories?.[1].url}
            target="_blank"
          >
            {locales.categories?.[3].title}
          </Link>{' '}
          {locales.categories?.[3].details}
        </ListItem>
      </UnorderedList>
      <Text marginTop="space-16">{locales.conclude}</Text>
    </>
  );

  if (isInWebView) {
    return (
      <Drawer isOpen={isOpen} onClose={onClose} placement="bottom">
        <DrawerOverlay />
        <DrawerContent margin={0}>
          <DrawerBody>
            <Heading marginBottom="space-24" textAlign="center">
              {locales.title}
            </Heading>

            {content}
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    );
  }

  return (
    <SunshineModal isOpen={isOpen} onClose={onClose}>
      <SunshineModal.Header></SunshineModal.Header>

      <SunshineModal.Body>
        <SunshineModal.Title>{locales.title}</SunshineModal.Title>

        {content}
      </SunshineModal.Body>
    </SunshineModal>
  );
};

export default MixedActivityInfo;
